import { mutator } from 'satcheljs';
import { selectMailStoreItemById } from 'owa-mail-store';
import {
    isMeetingMessage,
    meetingMessageAddToCalendarStatusChanged,
    MeetingMessageAddToCalendarStatus,
} from 'owa-meeting-message';
import { showSxS } from '../actions/publicActions';
import sxsStore from '../store/Store';

mutator(showSxS, ({ extendedViewState }) => {
    if (extendedViewState?.attachmentId) {
        const item = selectMailStoreItemById(extendedViewState.attachmentId.Id);
        sxsStore.meetingMessageAddToCalendarStatus =
            item && !isMeetingMessage(item)
                ? MeetingMessageAddToCalendarStatus.Disabled
                : MeetingMessageAddToCalendarStatus.Available;
    }
});

mutator(meetingMessageAddToCalendarStatusChanged, ({ status }) => {
    sxsStore.meetingMessageAddToCalendarStatus = status;
});
